import myImage1 from "../../images/hakkımızda-ben.png";


export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Hakkımda",
  headline: "MERHABA!",
  prop:"Ben Elif Yiğit Karslı",
  description:
    "İzmir'de yaşayan serbest grafik tasarımcı, art direktörüm. Lise eğitimiyle başlayan ve güzel sanatlar fakültesiyle kendimi geliştirdiğim sanat, tasarım serüvenime profesyonel olarak uzun yıllardır devam ediyorum. Global çapta birçok projede birden çok markaya kendi dokunuşlarımı katarak yaratıcı tasarımlara imza attım. Grafik tasarım,video ve multidisipliner birçok alanda hizmet veriyorum. Markanız, projeniz, iş teklifleriniz için benimle iletişime geçebilirsiniz.",
  imgStart: false,
  img: myImage1,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
  
  
};
